export const MSC_ENVIRONMENTS = [
  'experimental',
  'test',
  'production',
]

export const STORAGE_KEYS_PREFIX = 'ms::pdf-extra-web::'

export const FINGERPRINT_JS_VERSION_URL = 'https://openfpcdn.io/fingerprintjs/v3'

export const GOOGLE_ADS_URL = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js'

export const MIME_TYPES_TO_EXTENSION: { [key: string]: string } = {
  'video/3gpp': '3gp',
  'video/3gpp2': '3g2',
  'video/avi': 'avi',
  'video/x-msvideo': 'avi',
  'video/x-flv': 'flv',
  'video/x-matroska': 'mkv',
  'video/quicktime': 'mov',
  'video/mp4': 'mp4',
  'video/mpeg': 'mpeg',
  'video/ogg': 'ogg',
  'video/webm': 'webm',
  'video/x-ms-wmv': 'wmv',
  'audio/aac': 'aac',
  'audio/ac3': 'ac3',
  'audio/flac': 'flac',
  'audio/x-flac': 'flac',
  'audio/m4a': 'm4a',
  'audio/midi': 'mid',
  'audio/x-midi': 'mid',
  'audio/mpeg': 'mp3',
  'audio/opus': 'opus',
  'audio/ogg': 'ogg',
  'audio/wav': 'wav',
  'audio/x-ms-wma': 'wma',
  'application/postscript': 'ai',
  'image/avif': 'avif',
  'image/bmp': 'bmp',
  'image/dng': 'dng',
  'image/gif': 'gif',
  'image/heic': 'heic',
  'image/x-icon': 'ico',
  'image/jpeg': 'jpeg',
  'image/jpg': 'jpg',
  'image/jxl': 'jxl',
  'image/png': 'png',
  'image/vnd.adobe.photoshop': 'psd',
  'image/svg+xml': 'svg',
  'image/tiff': 'tiff',
  'image/webp': 'webp',
  'image/x-xcf': 'xcf',
  'application/x-7z-compressed': '7z',
  'application/vnd.android.package-archive': 'apk',
  'application/vnd.ms-cab-compressed': 'cab',
  'application/octet-stream': 'iso',
  'application/java-archive': 'jar',
  'application/vnd.rar': 'rar',
  'application/x-tar': 'tar',
  'application/x-bzip': 'tbz2',
  'application/gzip': 'tgz',
  'application/zip': 'zip',
  'text/csv': 'csv',
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'text/html': 'html',
  'application/json': 'json',
  'application/vnd.oasis.opendocument.presentation': 'odp',
  'application/vnd.oasis.opendocument.spreadsheet': 'ods',
  'application/vnd.oasis.opendocument.text': 'odt',
  'application/pdf': 'pdf',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow': 'pps',
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
  'application/rtf': 'rtf',
  'text/plain': 'txt',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.amazon.ebook': 'azw',
  'application/vnd.amazon.mobi8-ebook': 'azw3',
  'application/epub+zip': 'epub',
  'application/fb2': 'fb2',
  'application/x-mobipocket-ebook': 'mobi',
  'application/smil': 'smi'
}
